var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { LazyLoader } from '../../../ts/components/LazyLoader';
export class Home extends Component {
    constructor(isDebugEnabled = false) {
        super('Home', false);
        this.isScrolling = false;
        this.isRemoved = false;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('.module-home').length > 0) {
                if (sessionStorage.getItem('poster-removed') === 'true') {
                    $('body').addClass('scrolled');
                    $('.module-home').remove();
                    LazyLoader.checkImageVisibility();
                }
                else {
                    new BackgroundColorClassSwitcher($('.module-home'), 0, 4000, false);
                    new BackgroundColorClassSwitcher($('.module-home-logo'), 1, 2000, true);
                    $('.module-home').on('click', () => {
                        this.scrollDown();
                    });
                    $(window).on('scroll', () => {
                        if (this.isScrolling || this.isRemoved)
                            return;
                        this.scrollDown();
                    });
                }
            }
            $('.header-logo').on('click', (event) => {
                sessionStorage.setItem('poster-removed', 'false');
            });
            this.success();
        });
    }
    scrollDown() {
        return new Promise((resolve) => {
            this.isScrolling = true;
            $.scrollTo($(window).height(), 500);
            let intervalCount = 0;
            let intervalID = setInterval(() => {
                intervalCount++;
                if (intervalCount === 15) {
                    this.isScrolling = false;
                    this.remove();
                    clearInterval(intervalID);
                    resolve();
                }
            }, 40);
        });
    }
    remove() {
        $('.module-home').remove();
        window.scrollTo(0, 0);
        sessionStorage.setItem('poster-removed', 'true');
        this.isRemoved = true;
    }
}
class BackgroundColorClassSwitcher {
    constructor(elements, index = 0, duration = 2500, isRandom = false) {
        this.colorClasses = ['bg-primary', 'bg-secondary'];
        this.currentIndex = 0;
        this.elements = elements;
        this.currentIndex = index;
        this.duration = duration;
        this.isRandom = isRandom;
        this.switch();
    }
    switch() {
        setTimeout(() => {
            this.elements.removeClass(this.colorClasses[this.currentIndex]);
            this.currentIndex = (this.currentIndex + 1) % this.colorClasses.length;
            this.elements.addClass(this.colorClasses[this.currentIndex]);
            this.switch();
        }, this.isRandom ? (this.duration / 2) + (Math.random() * this.duration / 2) : this.duration);
    }
}
